import Cookies from 'js-cookie';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import debounce from '|/helpers/debounce';

const Tab = styled.div`
  border: 5px solid pink;
  display: inline-block;
  padding: 0 15px 5px;
  border-radius: 20px 0 0 2px;
  border-style: solid;
  border-width: 1px 0 0 1px;
  cursor: help;
  z-index: 1000000000000;
  background-color: rgb(255 255 255 / 60%);
  text-align: left;
  max-height: 100%;
  overflow: auto;
  position: relative;
`;

const CenteredParagraph = styled.p`
  text-align: center;
  margin: 0 15px 5px;
`;

const CheckboxLabel = styled.label`
  text-align: center;
  display: block;
`;

const InputLabel = styled.label`
  margin-top: 15px;
  display: block;
`;

const FeatureBranches = () => {
  const [showInterface, setShowInterface] = useState(false);
  const [enableFeatureOverride, setEnableFeatureOverride] = useState(false);
  const [featureOverrideName, setFeatureOverrideName] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const featureOverrideCookie = Cookies.get('cvna-feature-enable') ?? '';
    const featureNameFromCookies = Cookies.get('cvna-feature-name') ?? '';
    const pageLoadEnable = featureOverrideCookie === 'true';
    setEnableFeatureOverride(pageLoadEnable);
    setFeatureOverrideName(featureNameFromCookies);
    setIsLoading(false);
  }, []);

  useEffect(() => {
    if (isLoading) {
      return;
    }
    Cookies.set('cvna-feature-enable', enableFeatureOverride.toString());
  }, [enableFeatureOverride, isLoading]);

  useEffect(() => {
    if (isLoading) {
      return;
    }
    Cookies.set('cvna-feature-name', featureOverrideName);
  }, [featureOverrideName, isLoading]);

  const isProduction = process.env.NODE_ENV === 'production';

  if (isProduction || isLoading) {
    return null;
  }

  const debounceUpdateText = debounce(setFeatureOverrideName, 50);

  return (
    <Tab>
      <CenteredParagraph
        onClick={() => setShowInterface(!showInterface)}
        data-analytics-id="pp_devpanel_feature"
      >
        Feature Override
      </CenteredParagraph>
      {showInterface && (
        <div>
          <CheckboxLabel>
            <input
              type="checkbox"
              defaultChecked={enableFeatureOverride}
              onChange={() => setEnableFeatureOverride(!enableFeatureOverride)}
            />
            <b>Enable Feature Testing?</b>
          </CheckboxLabel>
          <InputLabel>
            Name:
            <input
              type="text"
              disabled={!enableFeatureOverride}
              defaultValue={featureOverrideName}
              onChange={e => debounceUpdateText(e.target.value)}
            />
          </InputLabel>
        </div>
      )}
    </Tab>
  );
};

export default FeatureBranches;
